import React from 'react';
import type { TFunction } from 'i18next';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridColumn,
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { GetBudgetDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import { TKeys, useTranslation } from '../../../common/hooks/useTranslation';

import { BudgetInfo } from './BudgetInfo';

interface BudgetsSearchProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  onRowClick: (key: string) => Promise<void> | void | undefined;
  refresh?: boolean;
}

export const budgetForGrid = (
  t: TFunction<'clientLng', 'clientLng'>,
  tk: TKeys<'clientLng'>,
  budget: GetBudgetDto,
) => {
  return {
    key: budget.id,
    values: {
      'budget.systemNumber': budget.systemNumber,
      'budget.name': budget.name,
      'employee.name': budget.manager?.name,
      'employee.oneToolId': budget.manager?.oneToolId,
      status: <BudgetInfo id={budget.id} />,
      budget_active_yes_no: budget.active
        ? t(tk.common.yesUpperCase)
        : t(tk.common.noUpperCase),
    },
    isInactive: !budget.active,
  };
};

export const BudgetSearch: React.FC<BudgetsSearchProps> = props => {
  const { t, tk } = useTranslation('clientLng');

  const columns: GridColumn[] = [
    { header: t(tk.common.sysNumber), property: 'budget.systemNumber' },
    { header: t(tk.common.name), property: 'budget.name' },
    { header: t(tk.budget.managerName), property: 'employee.name' },
    {
      header: `${t(tk.budget.managerName)} - ${t(tk.common.oneToolId)}`,
      property: 'employee.oneToolId',
      exportOnly: true,
    },
    { header: t(tk.common.activeHe), property: 'budget_active_yes_no' },
    { header: '', property: 'status', noSorting: true, noFilter: true },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={true}
      initialOrderColumn="budget.name"
      availablePageSizes={[10, 20, 50]}
      emptyGridMessage={t(tk.budget.noBudgets)}
      onRowClick={props.onRowClick}
      withFilterInColumns={true}
      refresh={props.refresh}
      withHistory={true}
      showExport={true}
    />
  );
};
